/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { PureComponent } from 'react';
import { number, object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
    title: {
        position: 'absolute',
        textAlign: 'center',
        fontSize: '16px',
        color: theme.palette.copyright,
        width: '100%',
        bottom: '0',
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        margin: '3px 0',
    },
    shopBtn: {
        display: 'block',
        padding: '0px 8px',
        border: '2px solid',
        width: '100px',
        margin: '0 auto 10px auto',
        fontSize: '14px',
        textTransform: 'uppercase',
        borderRadius: '4px',
    },
    bannerContainer: {
        margin: '0px 3px',
        border: `1px solid ${theme.palette.colorNeutral30}`,
        boxShadow: `0 5px 4px -2px  ${theme.palette.colorNeutral30}`,
        borderRadius: '3px',
        display: 'block',
        '& img': {
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            marginBottom: '16px',
        },
    },
    bannerContainerMain: {
        height: '100%',
        position: 'relative',
        marginBottom: 16,
    },
    showAsOne: {
        width: '100%',
    },
    showAsTwo: {
        width: '50%',
        '& $title': {
            fontSize: '14px',
        },
    },
    showAsThree: {
        width: '33%',
        '& $title': {
            fontSize: '12px',
        },
    },
    showAsFour: {
        width: '25%',
        '& $title': {
            fontSize: '10px',
        },
    },
    backgroundColor: 'transparent',
});
class MobileBanners extends PureComponent {
    render() {
        const {
            classes, title, link, imgUrl, imgTitle, bannerAcross,
        } = this.props;

        // Display mobile banner per row on the basis of the banner across field
        const bannerPerRow = () => {
            switch (bannerAcross) {
                case 1:
                    return classes.showAsOne;
                case 2:
                    return classes.showAsTwo;
                case 3:
                    return classes.showAsThree;
                default:
                    return classes.showAsFour;
            }
        };

        return (
            <div className={`${bannerPerRow()} ${classes.bannerContainerMain}`}>
                <Link to={link} className={classes.bannerContainer}>
                    <img src={imgUrl} alt={imgTitle} />
                    <div className={classes.title}>
                        {title}
                    </div>
                </Link>
            </div>
        );
    }
}
MobileBanners.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
    link: string.isRequired,
    imgUrl: string.isRequired,
    imgTitle: string.isRequired,
    bannerAcross: number.isRequired,
};
export default withStyles(styles)(MobileBanners);
